import React, { Component } from 'react';

export default class CheckboxGroup extends Component {
	render() {
		return(
			<span>
				<input
					id={this.props.id}
					type='checkbox'
					title={this.props.title}
					name={this.props.id}
					className={`default-font ${this.props.customCheckboxClass}`}
					value={this.props.value}
					checked={this.props.checked}
					onChange={this.props.onChange}/>
				<label className={this.props.customClass}>{this.props.name}</label>
			</span>
		);
	}
}
